import './ReportFormSectionConfig.scss';
import { FieldPath } from '@form-ts/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button } from 'src/modules/common/components/Button';
import { HorizontalDivider } from 'src/modules/common/components/HorizontalDivider';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { Project } from 'src/modules/common/types/Project';
import { BodySmall01 } from 'src/modules/common/typography/BodySmall01';
import { LeadText } from 'src/modules/common/typography/LeadText';
import { CheckboxField } from 'src/modules/form/components/CheckboxField';
import { FormError } from 'src/modules/form/types/FormError';
import { ReportFormData } from 'src/modules/report/types/ReportFormData';
import { ReportFormFieldToggle } from 'src/modules/report/views/ReportFormFieldToggle';

type Props = {
  readonly field: FieldPath<ReportFormData, FormError, ReportFormData['savings']>;
  readonly project: Project;
};

export const ReportFormSectionConfigSavings = ({ field, project }: Props): React.ReactElement => (
  <div className="bp-report-form-section-config">
    <div className="bp-report-form-section-config__header">
      <BodySmall01>
        <FormattedMessage id="report/form/savings/header"/>
      </BodySmall01>

      <CheckboxField field={field.at('enabled')}/>
    </div>

    <HorizontalDivider/>

    <div className="bp-report-form-section-config__content">
      <ReportFormFieldToggle field={field.at('showPotentialSavings')}>
        <FormattedMessage id="report/form/savings/showPotentialSavings"/>
      </ReportFormFieldToggle>

      <ReportFormFieldToggle field={field.at('showOverallEfficiency')}>
        <FormattedMessage id="report/form/savings/showOverallEfficiency"/>
      </ReportFormFieldToggle>

      <ReportFormFieldToggle field={field.at('showPerAreaEfficiency')}>
        <FormattedMessage id="report/form/savings/showPerAreaEfficiency"/>
      </ReportFormFieldToggle>
    </div>

    <div className="bp-report-form-section-config__action">
      <Button
        fullWidth={true}
        as={Link}
        to={`/project/${encodeURIComponent(project.id)}/hvac`}
        kind="tertiary"
        size="md"
      >
        <FormattedMessage id="report/form/savings/editLinkText"/>

        <div className="bp-report-form-section-config__button-icon">
          <ArrowRightIcon/>
        </div>
      </Button>
    </div>
  </div>
);
